export { default as Bajas } from "./BajasContainer";
